module.exports = require('./lib/effects')


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-saga/effects.js
 ** module id = 37
 ** module chunks = 0
 **/